import type { FilterType } from '../../../../../../api/screensService/getScreensFilterOptions/enums';
import type { SetFilterListBottomSheetViaQueryValueProps } from '../../Provider/filterListBottomSheet/useFilterListBottomSheetAtom';
import { useFilterHeader } from '../useFilterHeader';
import { SmallCategory } from './SmallCategory';
import { BigCategory } from './BigCategory';
import { RenderItemWrapper } from '../RenderItemWrapper';
import type { SetListHeight } from '../../hooks/useListHeight';

export type ISingleTreeChildGroup = {
  title: string;
  type: FilterType.SingleTree;
  entity: {
    queryName: string;
    selectedQueryValue: string | null;
    possibleItems: {
      queryValue: string;
      parentQueryValue: string | null;
      countText: string;
      isSelected: boolean;
      text: string;
      childList: {
        queryValue: string;
        parentQueryValue: string;
        countText: string;
        isSelected: boolean;
        text: string;
      }[];
    }[];
  };
  handleClickFilter: (
    props: SetFilterListBottomSheetViaQueryValueProps & { title: string },
  ) => void;
  setListHeight: SetListHeight;
  index: number;
};
type SingleTreeProps = ISingleTreeChildGroup;
export const SingleTreeFilter = ({
  index,
  title,
  handleClickFilter,
  setListHeight,
  entity: { selectedQueryValue, queryName, possibleItems },
}: SingleTreeProps) => {
  const { Header } = useFilterHeader({ title });

  const handleClickItem = (newValue: string) => {
    handleClickFilter({
      queryName: queryName,
      queryValue: newValue ? [newValue] : [],
      title,
    });
  };

  return (
    <RenderItemWrapper
      setListHeight={setListHeight}
      index={index}
      title={title}
    >
      <Header />
      {selectedQueryValue ? (
        <SmallCategory
          categoryList={possibleItems[0].childList}
          headerText={`${possibleItems[0].text} ${possibleItems[0].countText}`}
          handleClickItem={handleClickItem}
          selectedQueryValue={selectedQueryValue}
        />
      ) : (
        <BigCategory
          categoryList={possibleItems}
          handleClickItem={handleClickItem}
        />
      )}
    </RenderItemWrapper>
  );
};
